export type BrandInfo = {
  name: string
  description: string
  tgName?: string
  vkName?: string
  logo: string
  url: string
  email: string
  phone: string
  /** Юридическое наименование продавца (для оферты и согласий). */
  legalName: string
  inn: string
  ogrn: string
  address: string
  /** Город отправки / локальный самовывоз в FAQ. */
  city: string
}

export const brandInfo: BrandInfo = {
  name: 'Skuby',
  description: 'Skuby is a company that sells skuby products.',
  logo: 'logos/logo-large-light.svg',
  url: 'https://skuby.com',
  email: 'info@skuby.com',
  phone: '+7 (999) 999-99-99',
  tgName: 'skuby',
  vkName: 'skuby',
  legalName: 'ООО «Skuby»',
  inn: '0000000000',
  ogrn: '0000000000000',
  address: 'Российская Федерация',
  city: 'Москва',
}

/** Хост сайта без протокола и завершающего слэша. */
export function brandSiteHost(info: BrandInfo = brandInfo): string {
  return info.url.replace(/^https?:\/\//, '').replace(/\/$/, '')
}
